<template>
  <div class="ModalRemoving">
    <h4>Files are still being removed</h4>
    <p>
      Please wait until your files are removed before moving to a
      different page.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ModalRemoving'
}
</script>

<style scoped lang="scss">
.ModalRemoving {
  padding: 1rem 2rem;
  h4 {
    margin-bottom: 2rem;
    color: $color-primary;
    font-weight: bold;
    font-size: 22px;
  }
}
</style>
